import React, { useCallback, useEffect, useState } from 'react'
import { Button, Form, Spin } from 'antd'
import { postCreateSection } from '../../../../config'
import { itemsSteps, getFormInfo, getListAdd } from '../util/FormHelper'
import TapOptions from './TapOptions'
import StepForm from './StepForm'
import FormIteamInformation from './FormIteamInformation'
import FormIteamSpace from './FormIteamSpace'
import useForm from '../hooks/useForm'
import FormIteamLists from './FormIteamLists'

const FormSection = ({ onClose }) => {

    const {
        form,
        color,
        infoClickup,
        loading,
        changeColor,
        setLoading,
        getSpacesClickupForSection,
        getListsByClickupSpace
    } = useForm({ data: {} })

    const [currentStep, setCurrentStep] = useState(0);

    const handleNextStep = async () => {
        if (currentStep === itemsSteps.length - 1) return lastStep();

        try {
            await form.validateFields();
            const nextStep = currentStep + 1;
            setCurrentStep(nextStep);
            switch (nextStep) {
                case 1:
                    getSpacesClickupForSection();
                    break;
                case 2:
                    getListsByClickupSpace();
                    break;
                default:
                    break;
            }
        } catch (error) {
            console.log(error);
        }
    }

    const lastStep = () => {
        setLoading(true);
        const formList = form.getFieldValue(undefined);
        const listsClickup = getListAdd(formList.lists, infoClickup.lists)
        const formFinish = {
            name: formList.name,
            year: parseInt(formList.year.format('YYYY')),
            installed_capacity: formList.installed_capacity,
            color,
            type: formList.type,
            listsClickup
        }
        postCreateSection(formFinish)
            .then(() => {
                onClose()
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setLoading(false);
            })
    }


    const initForm = useCallback(() => {
        const { infoForm, color } = getFormInfo({})
        form.setFieldsValue(infoForm);
        changeColor({ target: { value: color } })
    }, [form, changeColor]);

    useEffect(() => initForm(), [initForm]);


    return (
        <div className='relative w-full h-[600px] flex flex-col gap-2'>
            {loading && (
                <div className='absolute top-0 left-0 w-full h-full bg-white z-20 flex justify-center items-center'>
                    <Spin size="large" />
                </div>
            )}
            <div>
                <TapOptions tabs={itemsSteps} selectIteam={currentStep}></TapOptions>
            </div>
            <Form form={form} className="w-full h-full " layout="vertical">
                <StepForm className={'w-full h-full px-4 pt-6 pb-2'} currentStep={currentStep}>
                    {/* Guarda Informacion Section */}
                    <StepForm.Step>
                        <FormIteamInformation
                            color={color}
                            changeColor={changeColor}
                        />
                    </StepForm.Step>

                    {/* Seleciona Espacios */}
                    <StepForm.Step>
                        <div className='w-full h-ful'>
                            <FormIteamSpace
                                spaces={infoClickup.spaces}
                            />
                        </div>
                    </StepForm.Step>

                    {/* Seleciona Listas */}
                    <StepForm.Step className={"w-full h-full overflow-y-auto"}>
                        <div className='w-full h-full'>
                            <FormIteamLists
                                lists={infoClickup.lists}
                            />
                        </div>
                    </StepForm.Step>
                </StepForm>
            </Form>

            <div className='w-full flex gap-2 justify-end'>
                {currentStep > 0 && (
                    <Button
                        onClick={() => setCurrentStep(currentStep - 1)}
                    >
                        Atrás
                    </Button>
                )}
                <Button
                    onClick={() => handleNextStep()}
                    type="primary"
                >
                    {currentStep === itemsSteps.length - 1 ? 'Guardar' : 'Siguiente'}
                </Button>

            </div>
        </div>
    )
}

export default FormSection